import axiosInstance from "src/common/axiosInstance";

const PIPELINES_ENDPOINT = "/admin/pipelines/pipelines";

export async function updatePipeline(pipelineId, payload) {
  const response = await axiosInstance.put(
    `${PIPELINES_ENDPOINT}/${pipelineId}`,
    payload
  );

  return response?.data?.data ?? response?.data;
}

export async function deletePipeline(pipelineId) {
  const response = await axiosInstance.delete(
    `${PIPELINES_ENDPOINT}/${pipelineId}`
  );

  return response?.data;
}